import React from 'react';

import { CheckboxWrapper, CheckedIcon } from './styles';

export const CheckboxChecked = (): JSX.Element => (
  <CheckboxWrapper checked={true}>
    <CheckedIcon />
  </CheckboxWrapper>
);
